import React from 'react';

// Create a padded bordered cell.
function PaddedBorderedCell(props: PaddedBorderedCellProps): JSX.Element {
  return (
    <td className="guidelines-paddedCell" {...props}>
      {props.children}
    </td>
  );
}

interface PaddedBorderedCellProps {
  children?: React.ReactNode;
}

export default PaddedBorderedCell;
